import { render, staticRenderFns } from "./OpusText.vue?vue&type=template&id=21ccb738&scoped=true&"
import script from "./OpusText.vue?vue&type=script&lang=js&"
export * from "./OpusText.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21ccb738",
  null
  
)

export default component.exports